"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTodayArrived = exports.isTodayDeparted = exports.getReservationStatusFromBusStatus = void 0;
const dayjs = require("dayjs");
function getReservationStatusFromBusStatus(bus, direction, spotId, spotTimingOccurence) {
    var _a;
    const today = dayjs(Date());
    const todayTravelChange = ((_a = bus.todayBusDeparted) === null || _a === void 0 ? void 0 : _a.today) &&
        dayjs(bus.todayBusDeparted.today).isSame(today, 'day') &&
        bus.todayBusDeparted.busDeparted.find(bd => bd.hour === spotTimingOccurence.hour &&
            bd.minute === spotTimingOccurence.minute &&
            bd.spotId === spotId &&
            bd.direction === direction);
    const busStatus = (bus.status === "in-rotation" &&
        !todayTravelChange) ? "ready" : bus.status;
    switch (busStatus) {
        case "ready":
            return direction === "departure" ? "started" : "done";
        case "in-rotation":
            return direction === "departure" ? "in-activity" : "finalize";
        default:
            return undefined;
    }
}
exports.getReservationStatusFromBusStatus = getReservationStatusFromBusStatus;
function isTodayDeparted(params) {
    var _a;
    const today = dayjs(Date());
    const todayTravelChange = ((_a = params.bus.todayBusDeparted) === null || _a === void 0 ? void 0 : _a.today) &&
        dayjs(params.bus.todayBusDeparted.today).isSame(today, 'day') &&
        params.bus.todayBusDeparted.busDeparted.find(bd => bd.hour === params.spotTimingOccurence.hour &&
            bd.minute === params.spotTimingOccurence.minute &&
            bd.spotId === params.spotId &&
            bd.direction === params.direction);
    return todayTravelChange !== undefined && todayTravelChange.spotId !== undefined ? true : false;
}
exports.isTodayDeparted = isTodayDeparted;
function isTodayArrived(params) {
    var _a;
    const today = dayjs(Date());
    const todayTravelChange = ((_a = params.bus.todayBusArrived) === null || _a === void 0 ? void 0 : _a.today) &&
        dayjs(params.bus.todayBusArrived.today).isSame(today, 'day') &&
        params.bus.todayBusArrived.busArrived.find(bd => bd.hour === params.spotTimingOccurence.hour &&
            bd.minute === params.spotTimingOccurence.minute &&
            bd.spotId === params.spotId &&
            bd.direction === params.direction);
    return todayTravelChange !== undefined && todayTravelChange.spotId !== undefined ? true : false;
}
exports.isTodayArrived = isTodayArrived;
//# sourceMappingURL=status.js.map